<script setup lang="ts">
import { useContactsStore } from '@/entities/Stores/Contacts';
import { HotlineButton } from '@/shared/ui/HotlineButton';
import { WhatsAppButton } from '@/shared/ui/WhatsAppButton';

const contactsStore = useContactsStore();
</script>

<template>
  <div class="get-in-touch">
    <b class="get-in-touch__title">{{ $t('renew.get_in_touch.header') }}</b>
    <p class="get-in-touch__text">
      {{ $t('renew.get_in_touch.subtitle') }}
    </p>
    <div class="get-in-touch__wrapper">
      <WhatsAppButton :href="contactsStore.whatsAppLink" type="ghost" />
      <HotlineButton variant="outline" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'GetInTouch';
</style>
